import { DepartmentEstimate } from '@interfaces/DepartmentEstimate';
import { Estimate } from '@interfaces/Estimate';

export class DepartmentEstimateHelper {

    public static SetIsAssociatedToAllStructures(de: DepartmentEstimate, estimate: Estimate) {
      
        const isAssociated = estimate.structures.every(s=>{

            const hasEstimateLine = s.estimateLines.find(el=>{
                return el.departmentEstimateId == de.id;
            });
            return hasEstimateLine;
        });
        de.isAssociatedToAllStructures = isAssociated;

        return isAssociated;
    }
}  